<template>
  <div>
    <div>
      <label>Название</label>
      <textarea class="form-control" v-model="title"></textarea>
    </div>
    <div style="padding:10px 0">
      Отображать на карте с машинами <input type="checkbox" v-model="showOnMap">
    </div>
    <div>
      <Sketch v-model="color" :disableAlpha="true" />
    </div>
    <div class="area-block">
      <div class="area-block-title">
        Срабатывание при въезде <input type="checkbox" v-model="triggerEntry">
      </div>
      <div v-if="triggerEntry" class="area-settings">
        <div>
          <label>Задержка срабатывания (мин)</label>
          <div class="input-group mb-3">
            <input type="number" class="form-control" v-model="triggerTimeoutEntry">
          </div>
        </div>
        <div>
          <label>Сообщение</label>
          <textarea class="form-control" v-model="triggerMessageEntry"></textarea>
        </div>
      </div>
    </div>
    <div class="area-block">
      <div class="area-block-title">
        Срабатывание при выезде <input type="checkbox" v-model="triggerEscape">
      </div>
      <div v-if="triggerEscape" class="area-settings">
        <div>
          <label>Задержка срабатывания (мин)</label>
          <div class="input-group mb-3">
            <input type="number" class="form-control" v-model="triggerTimeoutEscape">
          </div>
        </div>
        <div>
          <label>Сообщение</label>
          <textarea class="form-control" v-model="triggerMessageEscape"></textarea>
        </div>
      </div>
    </div>
    <a class="btn btn-primary m-1" @click="save()">Сохранить</a>
    <a class="btn btn-danger m-1" @click="remove()">Удалить</a>
  </div>
</template>

<script>
import { Sketch } from 'vue-color'
import RestrictedArea from '../api'

export default {
  name: 'AreaPropEditor',
  components: {
    Sketch
  },
  props: {
    mapArea: Object
  },
  data () {
    return {
      showOnMap: true,
      triggerEntry: false,
      triggerEscape: false,
      triggerTimeoutEntry: 10,
      triggerTimeoutEscape: 10,
      triggerMessageEntry: '',
      triggerMessageEscape: '',
      color: '#008000',
      title: ''
    }
  },
  methods: {
    save () {
      let color = this.color
      if (typeof color !== 'string') {
        color = color.hex
      }
      RestrictedArea.updateItem({
        id: this.mapArea.id,
        title: this.title,
        color,
        show_on_map: this.showOnMap,
        trigger_entry: this.triggerEntry,
        trigger_escape: this.triggerEscape,
        trigger_timeout_entry: this.triggerTimeoutEntry,
        trigger_timeout_escape: this.triggerTimeoutEscape,
        trigger_message_entry: this.triggerMessageEntry,
        trigger_message_escape: this.triggerMessageEscape
      })
        .then(({ model }) => this.$emit('update', model))
        .catch(err => {
          console.error('Ошибка обновения полигона, обновите страницу')
          console.error(err)
        })
    },
    remove () {
      RestrictedArea.removeItem(this.mapArea.id)
        .then(() => this.$emit('delete', this.mapArea))
        .catch(err => {
          console.error('Ошибка удаления полигона, обновите страницу')
          console.error(err)
        })
    }
  },
  watch: {
    mapArea: {
      immediate: true,
      handler (mapArea) {
        this.showOnMap = mapArea.show_on_map
        this.color = mapArea.color || '#008000'
        this.title = mapArea.title
        this.triggerEntry = mapArea.trigger_entry
        this.triggerEscape = mapArea.trigger_escape
        this.triggerTimeoutEntry = mapArea.trigger_timeout_entry
        this.triggerTimeoutEscape = mapArea.trigger_timeout_escape
        this.triggerMessageEntry = mapArea.trigger_message_entry
        this.triggerMessageEscape = mapArea.trigger_message_escape
      }
    }
  }
}
</script>

<style scoped>
  .area-block {
    padding-top: 10px;
  }
  .area-block-title {
    padding-bottom: 10px;
  }
  .area-settings {
    margin-left: 15px;
  }
  ::v-deep .vc-sketch {
    width: 200px;
    padding: 0;
    border: none;
    box-shadow: none;
  }
</style>
